var Handlebars = require('/builds/lp-digital/backbee/toolbar-legacy/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "  <div class=\"cloud-page-action d-flex\">\n    <button type=\"button\" class=\"edit mr-3\"><i class=\"icon icon-edit text-white\"></i></button>\n    <button type=\"button\" class=\"remove\"><i class=\"icon icon-trash text-white\"></i></button>\n  </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <button type=\"button\" class=\"cloud-page-action remove\">"
    + container.escapeExpression((lookupProperty(helpers,"trans")||(depth0 && lookupProperty(depth0,"trans"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"remove",{"name":"trans","hash":{},"data":data,"loc":{"start":{"line":7,"column":57},"end":{"line":7,"column":77}}}))
    + "</button>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"customUrl") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "");
},"useData":true});